import React, { Component, Fragment } from "react";

import Loader from "../../components/Loader/Loader";
import ErrorHandler from "../../components/ErrorHandler/ErrorHandler";

import Content from "../../components/Content/ContentPage/Content";
import ContentHeader from "../../components/Content/ContentHeader/ContentHeader";
import Card from "../../components/Card/Card";
import CardContent from "../../components/Card/CardContent/CardContent";
import Section from "../../components/Section/Section";
import Summary from "../../components/Summery/Summary";
import MainCard from "../../components/Card/MainCard/MainCard";

import AttributeGroup from "../../components/AttributeGroup/AttributeGroup";
import AttributeItem from "../../components/AttributeItem/AttributeItem";
import "./Attribute.css";

class Attribute extends Component {
  state = {
    categories: [],
    summeries: [],
    isChildSummerySelected: false,
    isAttributeGroupSelected: false,
    categoriesLoading: true,
    parentCode: {},
    functionButtonsLoading: false,
    error: null,

    attributeGroups: [],
    editAttributeGroup: false,

    attributes: [],
    editAttribute: false,

    attributeItems: [],
    editAttributeItems: false,

    selectedAttributeGroupCode: 0,
    selectedAttributeGroupTitle: "",
  };

  componentDidMount() {
    const graphqlQuery = {
      query: `
        query {
          categories(depth: 1){
            code
            name 
            secondName
            enName
            dataTheme
            isUniformPackaging
            hasChildren
            displayOrder
          }
        }
      `,
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors) {
          throw new Error("مشکل در دریافت گروه کالایی!");
        }
        this.setState({
          categories: [resData.data.categories],
          categoriesLoading: false,
        });
      })
      .catch(this.catchError);
  }

  newResetHandler = () => {
    this.setState({
      categories: [],
      categoriesLoading: false,
      summeries: [],
      isChildSummerySelected: false,
    });

    const graphqlQuery = {
      query: `
        query {
          categories(depth: 1){
            code
            name 
            secondName
            enName
            dataTheme
            isUniformPackaging
            hasChildren
            displayOrder
          }
        }
      `,
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors) {
          throw new Error("مشکل در دریافت گروه کالایی!");
        }
        this.setState({
          categories: [resData.data.categories],
          categoriesLoading: false,
          functionButtonsLoading: false,
        });
      })
      .catch(this.catchError);
  };

  addCategoryParentHandler = () => {
    var parentCode = {};
    for (var i = 0; i < this.state.categories.length; i += 1) {
      for (let index = 0; index < this.state.categories[i].length; index++) {
        if (this.state.categories[i][index].secondName !== "") {
          this.state.categories[i][index].name +
            " (" +
            this.state.categories[i][index].secondName +
            ")" ===
            this.state.summeries[this.state.summeries.length - 1] &&
            (parentCode = this.state.categories[i][index]);
        } else {
          this.state.categories[i][index].name ===
            this.state.summeries[this.state.summeries.length - 1] &&
            (parentCode = this.state.categories[i][index]);
        }
      }
    }

    if (this.state.isChildSummerySelected) {

    const graphqlQuery = {
      query: `
            query AttributeGroups($categoryCode: Int) {
              attributeGroups(categoryCode: $categoryCode){
                code
                title
                isActive
              }
            }
          `,
      variables: {
        categoryCode: parentCode.code,
      },
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors) {
          throw new Error("مشکل در دsریافت اطلاعات!");
        }

        this.setState({
          attributeGroups: resData.data.attributeGroups,
          parentCode: parentCode,
          functionButtonsLoading: true,
        });
      })
      .catch(this.catchError);
    } else {
      this.setState({
          parentCode: parentCode,
          functionButtonsLoading: true,
      });
    }
  };

  loadAttributes = () => {
    const graphqlQuery = {
      query: `
        query Attributes($attributeGroupCode: Int) {
          attributes(attributeGroupCode: $attributeGroupCode){
            code
            title
            isActive
            unit
            isRequire
            isRequire
            attributeTypeId
          }
        }
      `,
      variables: {
        attributeGroupCode: this.state.selectedAttributeGroupCode,
      },
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors) {
          throw new Error("مشکل در دریافت اطلاعات!");
        }

        this.setState(
          {
            attributes: resData.data.attributes,
            functionButtonsLoading: true,
            isAttributeGroupSelected: true,
          },
          () => {
            // console.log(this.state.attributes);
          }
        );
      })
      .catch(this.catchError);
  };

  onSelectHandler = (parentCode) => {
    var indexOfParent = 0;
    for (var i = 0; i < this.state.categories.length; i += 1) {
      for (let index = 0; index < this.state.categories[i].length; index++) {
        this.state.categories[i][index].code === parentCode.code &&
          (indexOfParent = i);
      }
    }
    this.setState({
      categories: this.state.categories.slice(0, indexOfParent + 1),
      summeries: this.state.summeries.splice(
        indexOfParent,
        this.state.summeries.length
      ),
      functionButtonsLoading: false,
    });

    var summeryName = "";
    var isChildSummerySelected = false;
    for (var j = 0; j < this.state.categories.length; j += 1) {
      for (let index = 0; index < this.state.categories[j].length; index++) {
        if (this.state.categories[j][index].code === parentCode.code) {
          summeryName = this.state.categories[j][index].name;
          if (this.state.categories[j][index].secondName) {
            summeryName =
              summeryName +
              " (" +
              this.state.categories[j][index].secondName +
              ")";
          }
          if (!this.state.categories[j][index].hasChildren) {
            isChildSummerySelected = true;
          }
        }
      }
    }

    if (summeryName !== "") {
      var joined = this.state.summeries.concat(summeryName);
      this.setState({
        summeries: joined,
        isChildSummerySelected: isChildSummerySelected,
      });
    }

    const graphqlQuery = {
      query: `
        query FetchSubCategories($parentCode: Int) {
          subCategories(parentCode: $parentCode){
            code  
            name 
            secondName
            enName
            dataTheme
            isUniformPackaging
            hasChildren
            displayOrder
          }
        }
      `,
      variables: {
        parentCode: parentCode.code,
      },
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors) {
          throw new Error("مشکل در دریافت گروه کالایی!");
        }

        if (resData.data.subCategories.length) {
          var flag = false;
          for (var i = 0; i < this.state.categories.length; i += 1) {
            flag =
              this.state.categories[i][0].code ===
              resData.data.subCategories.code
                ? true
                : false;
          }
          if (!flag) {
            this.setState({
              categories: [
                ...this.state.categories,
                resData.data.subCategories,
              ],
              categoriesLoading: false,
            });
          }
        }
      })
      .catch(this.catchError);
  };

  addAttributeGroupHandler = (postData) => {
    // this.setState({
    //   functionButtonsLoading: false,
    // });

    let graphqlQuery = {
      query: `
        mutation createNewAttributeGroup($categoryCode: Int!, $title: String!) {
            createAttributeGroup(attributeGroupInput: {categoryCode: $categoryCode, title: $title}) {
            code
            title
            isActive
            }
        }
        `,
      variables: {
        categoryCode: this.state.parentCode.code,
        title: postData.title,
      },
    };
    if (this.state.editAttributeGroup) {
      graphqlQuery = {
        query: `
        mutation updateNewAttributeGroup($code: Int!, $categoryCode: Int!, $title: String!) {
            updateAttributeGroup(code: $code, attributeGroupInput: {categoryCode: $categoryCode, title: $title}) {
            code
            title
            isActive
            }
        }
        `,
        variables: {
          code: postData.code,
          categoryCode: this.state.parentCode.code,
          title: postData.title,
        },
      };
    }

    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      body: JSON.stringify(graphqlQuery),
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors && resData.errors[0].status === 422) {
          throw new Error(
            "Validation failed. Make sure the email address isn't used yet!"
          );
        }
        if (resData.errors) {
          throw new Error("ورود کاربر ناموفق!");
        }

        if (this.state.editAttributeGroup) {
          var post = {
            code: resData.data.updateAttributeGroup.code,
            title: resData.data.updateAttributeGroup.title,
            isActive: resData.data.updateAttributeGroup.isActive,
          };
        } else {
          var post = {
            code: resData.data.createAttributeGroup.code,
            title: resData.data.createAttributeGroup.title,
            isActive: resData.data.createAttributeGroup.isActive,
          };
        }

        this.setState((prevState) => {
          let updatedPosts = [...prevState.attributeGroups];
          if (prevState.editAttributeGroup) {
            const postIndex = prevState.attributeGroups.findIndex(
              (p) => p.code === post.code
            );
            updatedPosts[postIndex] = post;
          } else {
            updatedPosts.push(post);
          }
          return {
            attributeGroups: updatedPosts,
            // functionButtonsLoading: true,
            editAttributeGroup: false,
          };
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isEditing: false,
          editAttributeGroup: false,
          editLoading: false,
          error: err,
        });
      });
  };

  cancelAttributeHandler = () => {
    this.setState({
      isAttributeGroupSelected: false,
      selectedAttributeGroupCode: 0,
      selectedAttributeGroupTitle: "",
    });
  };

  newAttributeHandler = (selectedAttributeGroupCode) => {
    const Index = this.state.attributeGroups.findIndex(
      (p) => p.code === selectedAttributeGroupCode
    );

    this.setState(
      {
        selectedAttributeGroupCode: selectedAttributeGroupCode,
        selectedAttributeGroupTitle: this.state.attributeGroups[Index].title,
      },
      () => {
        this.loadAttributes();
      }
    );

    // this.setState({
    //   attributes: this.loadAttributes(),
    //   isAttributeGroupSelected: true,
    // });
  };

  onEditHandler = (postData) => {
    this.setState(
      {
        editAttributeGroup: true,
      },
      () => {
        this.addAttributeGroupHandler(postData);
      }
    );
  };

  onDeleteHandler = (data) => {
    // console.log(data);
    // this.setState({
    //   functionButtonsLoading: false,
    // });
    const graphqlQuery = {
      query: `
        mutation {
          deleteAttributeGroup(attributeGroupCode: ${parseInt(data.code)})
        }
      `,
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors) {
          throw new Error("خطا در حذف گروه ویژگی!");
        }
        this.setState((prevState) => {
          let updatedPosts = [...prevState.attributeGroups];

          const postIndex = prevState.attributeGroups.findIndex(
            (p) => p.code === data.code
          );
          if (postIndex > -1) {
            updatedPosts.splice(postIndex, 1);
          }
          return {
            attributeGroups: updatedPosts,
            // functionButtonsLoading: true,
          };
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ functionButtonsLoading: true });
      });
  };

  errorHandler = () => {
    this.setState({ error: null });
  };

  catchError = (error) => {
    this.setState({ error: error });
  };

  addAttributeHandler = (postData) => {
    // this.setState({
    //   functionButtonsLoading: false,
    // });
    console.log(postData);

    let graphqlQuery = {
      query: `
        mutation createNewAttribute($attributeGroupCode: Int!, $title: String!, $unit: String!, $isRequire: Boolean!, $attributeTypeId: Int!) {
            createAttribute(attributeInput: {attributeGroupCode: $attributeGroupCode, title: $title, isRequire:$isRequire, unit: $unit, attributeTypeId: $attributeTypeId}) {
            code
            title
            isActive
            unit
            isRequire
            attributeTypeId
            }
        }
        `,
      variables: {
        attributeGroupCode: this.state.selectedAttributeGroupCode,
        title: postData.title,
        unit: postData.unit,
        isRequire: postData.isRequire == "true" ? true : false,
        attributeTypeId: postData.attributeTypeId,
      },
    };
    if (this.state.editAttribute) {
      graphqlQuery = {
        query: `
        mutation updateNewAttribute($code: Int!, $attributeGroupCode: Int!, $title: String!, $unit: String!, $isRequire: Boolean!, $attributeTypeId: Int!) {
            updateAttribute(code: $code, attributeInput: {attributeGroupCode: $attributeGroupCode, title: $title, isRequire:$isRequire, unit: $unit, attributeTypeId: $attributeTypeId}) {
            code
            title
            isActive
            unit
            isRequire
            attributeTypeId
            }
        }
        `,
        variables: {
          code: postData.code,
          attributeGroupCode: this.state.selectedAttributeGroupCode,
          title: postData.title,
          unit: postData.unit,
          isRequire: postData.isRequire == "true" ? true : false,
          attributeTypeId: postData.attributeTypeId,
        },
      };
    }

    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      body: JSON.stringify(graphqlQuery),
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        console.log(resData);
        if (resData.errors && resData.errors[0].status === 422) {
          throw new Error(
            "Validation failed. Make sure the email address isn't used yet!"
          );
        }
        if (resData.errors) {
          throw new Error("ورود کاربر ناموفق!");
        }
        var post;
        if (this.state.editAttribute) {
          post = {
            code: resData.data.updateAttribute.code,
            title: resData.data.updateAttribute.title,
            isActive: resData.data.updateAttribute.isActive,
            unit: resData.data.updateAttribute.unit,
            isRequire: resData.data.updateAttribute.isRequire,
            attributeTypeId: resData.data.updateAttribute.attributeTypeId,
          };
        } else {
          post = {
            code: resData.data.createAttribute.code,
            title: resData.data.createAttribute.title,
            isActive: resData.data.createAttribute.isActive,
            unit: resData.data.createAttribute.unit,
            isRequire: resData.data.createAttribute.isRequire,
            attributeTypeId: resData.data.createAttribute.attributeTypeId,
          };
        }

        this.setState((prevState) => {
          let updatedPosts = [...prevState.attributes];
          if (this.state.editAttribute) {
            const postIndex = prevState.attributes.findIndex(
              (p) => p.code === post.code
            );
            updatedPosts[postIndex] = post;
          } else {
            updatedPosts.push(post);
          }

          return {
            attributes: updatedPosts,
            // functionButtonsLoading: true,
            editAttribute: false,
          };
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isEditing: false,
          editAttribute: false,
          editLoading: false,
          error: err,
        });
      });
  };

  newAttributeItemHandler = (error) => {
    this.setState({ error: error });
  };

  onEditAttributeHandler = (postData) => {
    this.setState(
      {
        editAttribute: true,
      },
      () => {
        this.addAttributeHandler(postData);
      }
    );
  };

  onDeleteAttributeHandler = (data) => {
    // console.log(data);
    // this.setState({
    //   functionButtonsLoading: false,
    // });
    const graphqlQuery = {
      query: `
        mutation {
          deleteAttribute(attributeCode: ${parseInt(data.code)})
        }
      `,
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        console.log(resData);
        if (resData.errors) {
          throw new Error("خطا در حذف گروه ویژگی!");
        }
        this.setState((prevState) => {
          let updatedPosts = [...prevState.attributes];

          const postIndex = prevState.attributes.findIndex(
            (p) => p.code === data.code
          );
          if (postIndex > -1) {
            updatedPosts.splice(postIndex, 1);
          }
          return {
            attributes: updatedPosts,
            // functionButtonsLoading: true,
          };
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ functionButtonsLoading: true });
      });
  };

  render() {
    return (
      <Fragment>
        <ErrorHandler error={this.state.error} onHandle={this.errorHandler} />

        <Content>
          <ContentHeader
            headerAction="درج ویژگی‌های کالایی"
            headerDescription="اطلاعات ویژگی‌های کالایی را در این صفحه وارد کنید"
          />
          <Card>
            <CardContent cardTitle="انتخاب گروه کالایی">
              <section className="feed">
                {this.state.categoriesLoading && (
                  <div style={{ textAlign: "center", marginTop: "2rem" }}>
                    <Loader />
                  </div>
                )}
                {this.state.categories.length <= 0 &&
                !this.state.categoriesLoading ? (
                  <p style={{ textAlign: "center" }}>گروه کالایی وجود ندارد.</p>
                ) : null}
                <div className="mn-content-categories" id="categoriesContainer">
                  <div className="mn-content-categories__container">
                    {!this.state.categoriesLoading &&
                      this.state.categories.map((category) => (
                        <Section
                          categories={category}
                          onSelect={this.onSelectHandler.bind(this)}
                        />
                      ))}
                  </div>
                  <div className="mn-content-categories__summary">
                    <Summary
                      noneable={false}
                      summeries={this.state.summeries}
                      isChildSummerySelected={this.state.isChildSummerySelected}
                      newResetHandler={this.newResetHandler.bind(this)}
                      addCategoryParentHandler={this.addCategoryParentHandler.bind(
                        this
                      )}
                    />
                  </div>
                </div>
              </section>
            </CardContent>
          </Card>
          {this.state.functionButtonsLoading &&
            this.state.isChildSummerySelected && (
              <MainCard cardTitle="مدیریت گروه ویژگی‌های کالایی">
                <AttributeGroup
                  attributeGroups={this.state.attributeGroups}
                  onAcceptModal={this.addAttributeGroupHandler.bind(this)}
                  newAttributeHandler={this.newAttributeHandler.bind(this)}
                  onEditHandler={this.onEditHandler.bind(this)}
                  onDeleteHandler={this.onDeleteHandler.bind(this)}
                  cancelAttributeHandler={this.cancelAttributeHandler.bind(
                    this
                  )}
                />
              </MainCard>
            )}
          {this.state.functionButtonsLoading &&
            this.state.isChildSummerySelected &&
            this.state.isAttributeGroupSelected && (
              <MainCard
                cardTitle={
                  "مدیریت ویژگی‌های " + this.state.selectedAttributeGroupTitle
                }
              >
                <AttributeItem
                  attributes={this.state.attributes}
                  onAcceptModal={this.addAttributeHandler.bind(this)}
                  newAttributeItemHandler={this.newAttributeItemHandler.bind(
                    this
                  )}
                  onEditHandler={this.onEditAttributeHandler.bind(this)}
                  onDeleteHandler={this.onDeleteAttributeHandler.bind(this)}
                  token={this.props.token}
                />
              </MainCard>
            )}
        </Content>
      </Fragment>
    );
  }
}

export default Attribute;
